import api from "./api";

const ReadingTypeService = {
  
  save: async (data) => {
    const response = await api.post("/readingType/save", data);
    return response.data;
  },

  
getAllPaginated: async (pageNumber = 1, pageSize = 10) => {
  const res = await api.get(`/readingType/getAllPaginated?pageNumber=${pageNumber}&pageSize=${pageSize}`);
  return res.data;
},


  getAll: async () => {
    const response = await api.get("/readingType/getAll");
    return response.data;
  },

  
  getActive: async () => {
    const response = await api.get("/readingType/getActive");
    return response.data;
  },

  
  getById: async (id) => {
    const response = await api.get(`/readingType/getById/${id}`);
    return response.data;
  },

  
  update: async (id, data) => {
    const response = await api.put(`/readingType/update/${id}`, data);
    return response.data;
  },

  updateStatus: async (id, data) => {
    const response = await api.put(`/readingType/updateStatus/${id}`, data);
    return response.data;
  },
  
  
  remove: async (id) => {
    const response = await api.delete(`/readingType/${id}`);
    return response.data;
  },
};

export default ReadingTypeService;
